import React from 'react'

import { AmountField } from '@octane/spark'

import {
    FieldConfigBase,
    FieldKit,
    FieldProps,
    FormValues,
} from '../../containers/FormBuilder'

interface CurrencyAmountFieldConfig extends FieldConfigBase {
    label: string
    placeholder?: string
    disabled?: boolean
    onChange?: (
        value: number | string,
        fieldName: string,
        formValues: FormValues,
        fieldKit: FieldKit,
    ) => void
}

export default function CurrencyAmountField(
    props: FieldProps<CurrencyAmountFieldConfig>,
) {
    const { fieldName, fieldKit, fieldConfig } = props
    const touched = fieldKit.touched[fieldName]
    const error = fieldKit.errors[fieldName]
    const value = fieldKit.values[fieldName]

    return (
        <AmountField
            name={fieldName}
            id={fieldName}
            testID={fieldName}
            label={fieldConfig.label}
            disabled={fieldConfig.disabled}
            onBlur={fieldKit.handleBlur}
            placeholder={fieldConfig.placeholder ?? '0.00'}
            onChange={(val) => {
                const newValue = val.formattedValue !== '' ? val.floatValue : ''

                if (fieldConfig.onChange) {
                    fieldConfig.onChange(
                        newValue,
                        fieldName,
                        fieldKit.values,
                        fieldKit,
                    )
                } else {
                    const event = {
                        target: {
                            name: fieldName,
                            value: newValue,
                        },
                    }

                    fieldKit.handleChange(event)
                }
            }}
            error={!!(touched && error)}
            errorText={error}
            value={value}
            omitDecimals
        />
    )
}
